export default "__VITE_ASSET__BNDPbluF__"